/**
 * Permission constants matching the proto-generated Permission enum
 * in @stodge-inc/postscript-ts-protos (postscript/core/auth/v1/rbac.proto).
 *
 * Values are the snake_case DB names carried in the JWT. A companion test
 * (`constants.vitest.ts`) verifies these stay in sync with the proto at CI time.
 */
export const PERMISSIONS = {
  user_read: 'user_read',
  user_write: 'user_write',
  user_delete: 'user_delete',
  billing_read: 'billing_read',
  billing_write: 'billing_write',
  conversations_read: 'conversations_read',
  conversations_write: 'conversations_write',
  subscriber_opt_out: 'subscriber_opt_out',
  campaigns_read: 'campaigns_read',
  campaigns_write: 'campaigns_write',
  flows_read: 'flows_read',
  flows_write: 'flows_write',
  analytics_read: 'analytics_read',
  analytics_write: 'analytics_write',
  analytics_export: 'analytics_export',
  subscribers_read: 'subscribers_read',
  subscribers_write: 'subscribers_write',
  popups_read: 'popups_read',
  popups_write: 'popups_write',
  pii_read: 'pii_read',
  cashback_read: 'cashback_read',
  cashback_write: 'cashback_write',
  cashback_manage: 'cashback_manage',
  sms_sales_read: 'sms_sales_read',
  sms_sales_write: 'sms_sales_write',
  limit_sms_sales_agent_access: 'limit_sms_sales_agent_access',
  cannot_see_subscriber_pii: 'cannot_see_subscriber_pii',
} as const;

export const LEGACY_ROLES = {
  BILLING_ADMIN: 'BILLING_ADMIN',
  SUPERUSER: 'SUPERUSER',
  ROLE_MANAGER: 'ROLE_MANAGER',
  CONTENT_REVIEWER: 'CONTENT_REVIEWER',
  QA_TESTER: 'QA_TESTER',
  GTM_NOTIFICATION_RECIPIENT: 'GTM_NOTIFICATION_RECIPIENT',
  CONVERT_SALES_AGENT: 'CONVERT_SALES_AGENT',
  AI_ALPHA_TESTER: 'AI_ALPHA_TESTER',
  RECOMMENDED_ACTIONS_ALPHA: 'RECOMMENDED_ACTIONS_ALPHA',
  WORKSPACE_ALPHA_TESTER: 'WORKSPACE_ALPHA_TESTER',
  EMBEDDED_ANALYTICS_ADMIN: 'EMBEDDED_ANALYTICS_ADMIN',
} as const;

export const NOTIFICATION_NAME = {
  BILLING_SPEND_NOTIFICATION: 'BillingSpendNotification',
} as const;

export const NOTIFICATION_CHANNEL_TYPE = {
  TEXT: 'TEXT',
  EMAIL: 'EMAIL',
} as const;
